// we need to polyfill {}.entries, [].find & Symbol for IE11
import "babel-polyfill";
import './gdpr-cookie-control/gdpr-cookie-control';
